import { render, staticRenderFns } from "./TsPlayer.vue?vue&type=template&id=a6cbfe0c&"
import script from "./TsPlayer.vue?vue&type=script&lang=js&"
export * from "./TsPlayer.vue?vue&type=script&lang=js&"
import style0 from "./TsPlayer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
